import type { ReactElement } from 'react';
import { Route } from 'config';

import UpcomingMenu from 'models/UpcomingMenu';
import { useUpcomingMenu } from 'contexts/UpcomingMenu';

import Status from './Status';
import SkipWeekButton from './SkipWeekButton';
import ChangeMealsButton from './ChangeMealsButton';

type Props = {
  item: UpcomingMenu;
  showTutorialTooltip: boolean;
  showAutoSkipTooltip: boolean;
};

function Header({
  item,
  showTutorialTooltip,
  showAutoSkipTooltip,
}: Props): ReactElement {
  const {
    isModifiable,
    menu_id: menuId,
    cart_id: cartId,
  } = item;

  const { dispatch } = useUpcomingMenu();

  const cartUrl = Route.CARTS
    .replace(':menuId', menuId?.toString())
    .replace(':cartId', cartId?.toString());

  return (
    <div
      className="c-order__header"
    >
      <Status item={item} />

      {isModifiable && (
        <ChangeMealsButton
          href={cartUrl}
          className="d-none d-lg-inline-block"
          showTutorialTooltip={showTutorialTooltip}
        />
      )}
      <SkipWeekButton
        item={item}
        labelClassName="d-none d-sm-inline-block"
        showAutoSkipTooltip={showAutoSkipTooltip}
      />
    </div>
  );
}

export default Header;
